/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `string` - string
 * * `numeric` - numeric
 * * `positive_numeric` - positive_numeric
 * * `datetime` - datetime
 * * `list` - list
 * @export
 */
export const InformationExtractionSchemaFieldType = {
  string: 'string',
  numeric: 'numeric',
  positiveNumeric: 'positive_numeric',
  datetime: 'datetime',
  list: 'list',
} as const;
export type InformationExtractionSchemaFieldType =
  (typeof InformationExtractionSchemaFieldType)[keyof typeof InformationExtractionSchemaFieldType];

export function instanceOfInformationExtractionSchemaFieldType(value: any): boolean {
  for (const key in InformationExtractionSchemaFieldType) {
    if (Object.prototype.hasOwnProperty.call(InformationExtractionSchemaFieldType, key)) {
      if (
        (InformationExtractionSchemaFieldType as Record<string, InformationExtractionSchemaFieldType>)[key] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function InformationExtractionSchemaFieldTypeFromJSON(json: any): InformationExtractionSchemaFieldType {
  return InformationExtractionSchemaFieldTypeFromJSONTyped(json, false);
}

export function InformationExtractionSchemaFieldTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): InformationExtractionSchemaFieldType {
  return json as InformationExtractionSchemaFieldType;
}

export function InformationExtractionSchemaFieldTypeToJSON(value?: InformationExtractionSchemaFieldType | null): any {
  return value as any;
}
